<script>
  import { adminAuth } from "../../stores/adminAuth.js"
  import { push } from "svelte-spa-router"
  import AdminLayout from "./AdminLayout.svelte"
  import { onMount } from "svelte"
  import axios from "axios"

  $: authState = $adminAuth
  let currentPage = "target-sets"

  const API_URL = process.env.API_URL

  onMount(() => {
    // 初期ロード時にターゲット語セットページが表示されている場合のみ取得
    if (currentPage === "target-sets") {
      fetchTargetSets()
    }
  })

  async function fetchTargetSets() {
    try {
      const apiUrl = API_URL + "/admin/target-sets"
      console.log("Fetching target sets from:", apiUrl)

      const response = await axios.get(`${apiUrl}`)
      console.log("Fetched target sets:", response.data)

      // APIレスポンスからターゲット語セットを設定
      if (response.data && Array.isArray(response.data)) {
        targetSets = response.data.map((set) => ({
          id: set.id,
          name: set.set_name,
          description: set.description,
          set_type: set.set_type,
          target_words: set.target_words,
          recommended_vocab_set: set.recommended_vocab_set,
          created_at: set.created_at,
          updated_at: set.updated_at,
        }))

        // デフォルトで最初のセットを選択
        if (targetSets.length > 0 && !selectedSet) {
          selectSet(targetSets[0])
        }
      }
    } catch (error) {
      console.error("Error fetching target sets:", error)
      // エラー時は何も表示しない
      targetSets = []
    }
  }

  async function fetchVocabularySets() {
    try {
      const apiUrl = API_URL + "/admin/vocabulary-sets"
      console.log("Fetching vocabulary sets from:", apiUrl)

      const response = await axios.get(`${apiUrl}`)
      console.log("Fetched vocabulary sets:", response.data)

      // APIレスポンスから語彙セットを設定
      if (response.data && Array.isArray(response.data)) {
        vocabularySets = response.data.map((set) => ({
          id: set.id,
          set_name: set.set_name,
          description: set.description,
          set_type: set.set_type,
          positive_words: set.positive_words || [],
          negative_words: set.negative_words || [],
          created_at: set.created_at,
          updated_at: set.updated_at,
        }))

        // デフォルトで最初のセットを選択
        if (vocabularySets.length > 0 && !selectedVocabSet) {
          selectVocabSet(vocabularySets[0])
        }
      }
    } catch (error) {
      console.error("Error fetching vocabulary sets:", error)
      // エラー時は何も表示しない
      vocabularySets = []
    }
  }

  // ターゲット語セット管理
  let targetSets = []

  let selectedSet = null
  let editingWords = []
  let isNewSet = false // 新規セットフラグ
  let editingSetName = ""
  let editingSetId = ""
  let editingDescription = ""
  let isSaving = false // 保存中フラグ

  // バリデーション用の変数
  $: hasEmptyWords = editingWords.some((word) => !word.word.trim())
  $: isFormValid =
    editingSetName.trim() && editingSetId.trim() && !hasEmptyWords

  // 語彙管理用の状態
  let activeVocabTab = "positive" // "positive" | "negative"
  let vocabularySets = []
  let selectedVocabSet = null
  let isNewVocabSet = false
  let editingVocabSetName = ""
  let editingVocabSetId = ""
  let editingVocabDescription = ""
  let editingPositiveWords = []
  let editingNegativeWords = []
  let isSavingVocab = false

  // アンケート管理用の状態
  let questionnaireSets = []
  let selectedQuestionnaireSet = null
  let isNewQuestionnaireSet = false
  let editingQuestionnaireSetName = ""
  let editingQuestionnaireSetId = ""
  let editingQuestionnaireDescription = ""
  let editingQuestions = []
  let editingGradeOptions = []
  let isSavingQuestionnaire = false

  let selectedTargetSetId = ""
  let selectedVocabularySetId = ""
  let selectedQuestionnaireSetId = ""
  let generatedUrl = ""
  let baseUrl = window.location.origin

  // ページ遷移時にデータを再取得する
  let previousPage = ""
  $: if (currentPage === "target-sets" && previousPage !== "target-sets") {
    fetchTargetSets()
    previousPage = currentPage
  } else if (currentPage === "vocabulary" && previousPage !== "vocabulary") {
    fetchVocabularySets()
    previousPage = currentPage
  } else if (
    currentPage === "questionnaire" &&
    previousPage !== "questionnaire"
  ) {
    fetchQuestionnaireSets()
    previousPage = currentPage
  } else if (
    currentPage === "url-generator" &&
    previousPage !== "url-generator"
  ) {
    // URL生成ページでは全てのセットを取得
    fetchTargetSets()
    fetchVocabularySets()
    fetchQuestionnaireSets()
    previousPage = currentPage
  } else if (
    currentPage !== "target-sets" &&
    currentPage !== "vocabulary" &&
    currentPage !== "questionnaire" &&
    currentPage !== "url-generator"
  ) {
    // 他のページに遷移する時は編集内容を破棄
    clearEditingState()
    selectedSet = null
    isNewSet = false
    previousPage = currentPage
  }

  // ターゲット語セット関連の関数
  function selectSet(set) {
    // 新規セット作成中の編集内容を破棄
    clearEditingState()

    selectedSet = set
    isNewSet = false

    // フォーム項目を設定
    editingSetName = set.name || ""
    editingSetId = set.id || ""
    editingDescription = set.description || ""

    // APIから取得したターゲット語データを編集用に設定
    if (set && set.target_words) {
      editingWords = set.target_words.map((word) => ({
        id: word.id,
        word: word.word,
        type: word.type,
        enabled: word.enabled,
      }))
    } else {
      editingWords = []
    }
  }

  async function deleteTargetSet(setId, setName) {
    if (
      !confirm(
        `「${setName}」を削除してもよろしいですか？この操作は取り消せません。`
      )
    ) {
      return
    }

    try {
      const apiUrl = API_URL + "/admin/target-sets"
      console.log("Deleting target set:", setId)

      const response = await axios.delete(`${apiUrl}/${setId}`)
      console.log("Deleted successfully:", response.data)

      alert("ターゲット語セットを削除しました")

      // 削除されたセットが選択中だった場合、選択を解除
      if (selectedSet && selectedSet.id === setId) {
        selectedSet = null
        clearEditingState()
        isNewSet = false
      }

      // 最新状態を取得
      await fetchTargetSets()
    } catch (error) {
      console.error("Error deleting target set:", error)
      if (error.response && error.response.data) {
        alert(`削除に失敗しました: ${error.response.data}`)
      } else {
        alert("削除に失敗しました")
      }
    }
  }

  function createNewSet() {
    // 編集内容を破棄
    clearEditingState()

    selectedSet = null
    isNewSet = true

    // 新規セット用の初期値
    editingSetName = ""
    editingSetId = ""
    editingDescription = ""
    editingWords = [
      { id: Date.now(), word: "数学", type: "positive", enabled: true },
      { id: Date.now() + 1, word: "数学", type: "negative", enabled: true },
    ]
  }

  function clearEditingState() {
    editingSetName = ""
    editingSetId = ""
    editingDescription = ""
    editingWords = []
  }

  function removeWord(wordId) {
    editingWords = editingWords.filter((w) => w.id !== wordId)
  }

  function duplicateWord(word) {
    const duplicated = {
      ...word,
      id: Date.now(),
      word: word.word + " (コピー)",
    }
    editingWords = [...editingWords, duplicated]
  }

  function copyTargetSet(set) {
    isNewSet = true
    selectedSet = null

    editingSetName = set.name + " (コピー)"
    editingSetId = set.id + "_copy"
    editingDescription = set.description || ""

    if (set.target_words) {
      editingWords = set.target_words.map((word, index) => ({
        id: Date.now() + index,
        word: word.word,
        type: word.type,
        enabled: word.enabled,
      }))
    } else {
      editingWords = []
    }
  }

  function updateWordType(wordId, newType) {
    editingWords = editingWords.map((w) =>
      w.id === wordId ? { ...w, type: newType } : w
    )
  }

  function updateWordStatus(wordId, newStatus) {
    editingWords = editingWords.map((w) =>
      w.id === wordId ? { ...w, enabled: newStatus === "enabled" } : w
    )
  }

  function updateWordText(wordId, newText) {
    editingWords = editingWords.map((w) =>
      w.id === wordId ? { ...w, word: newText } : w
    )
  }

  function addNewWord() {
    const newWord = {
      id: Date.now(),
      word: "",
      type: "positive",
      enabled: true,
    }
    editingWords = [...editingWords, newWord]
  }

  function switchVocabTab(tab) {
    activeVocabTab = tab
  }

  // 語彙管理関数
  function selectVocabSet(set) {
    selectedVocabSet = set
    isNewVocabSet = false
    editingVocabSetName = set.set_name || ""
    editingVocabSetId = set.id || ""
    editingVocabDescription = set.description || ""
    editingPositiveWords = set.positive_words || []
    editingNegativeWords = set.negative_words || []
  }

  function createNewVocabSet() {
    selectedVocabSet = null
    isNewVocabSet = true
    editingVocabSetName = ""
    editingVocabSetId = ""
    editingVocabDescription = ""
    editingPositiveWords = ["平和", "希望", "幸福"]
    editingNegativeWords = ["戦争", "病気", "絶望"]
  }

  function addVocabWord(type) {
    if (type === "positive") {
      editingPositiveWords = [...editingPositiveWords, ""]
    } else {
      editingNegativeWords = [...editingNegativeWords, ""]
    }
  }

  function removeVocabWord(type, index) {
    if (type === "positive") {
      editingPositiveWords = editingPositiveWords.filter((_, i) => i !== index)
    } else {
      editingNegativeWords = editingNegativeWords.filter((_, i) => i !== index)
    }
  }

  function updateVocabWord(type, index, value) {
    if (type === "positive") {
      editingPositiveWords = editingPositiveWords.map((word, i) =>
        i === index ? value : word
      )
    } else {
      editingNegativeWords = editingNegativeWords.map((word, i) =>
        i === index ? value : word
      )
    }
  }

  function copyVocabularySet(set) {
    isNewVocabSet = true
    selectedVocabSet = null

    editingVocabSetName = set.set_name + " (コピー)"
    editingVocabSetId = set.id + "_copy"
    editingVocabDescription = set.description || ""
    editingPositiveWords = [...(set.positive_words || [])]
    editingNegativeWords = [...(set.negative_words || [])]
  }

  // アンケート管理関数
  function selectQuestionnaireSet(set) {
    selectedQuestionnaireSet = set
    isNewQuestionnaireSet = false
    editingQuestionnaireSetName = set.set_name || ""
    editingQuestionnaireSetId = set.id || ""
    editingQuestionnaireDescription = set.description || ""
    editingQuestions = set.questions || []
    editingGradeOptions = set.grade_options || []
  }

  function createNewQuestionnaireSet() {
    selectedQuestionnaireSet = null
    isNewQuestionnaireSet = true
    editingQuestionnaireSetName = ""
    editingQuestionnaireSetId = ""
    editingQuestionnaireDescription = ""
    editingQuestions = [
      {
        id: 1,
        type: "choice",
        question: "アンケート内容を入力してください",
        options: ["選択肢1", "選択肢2"],
      },
    ]
    editingGradeOptions = [
      "4年生",
      "5年生",
      "6年生",
      "中1",
      "中2",
      "中3",
      "高1",
      "高2",
      "高3",
      "その他",
    ]
  }

  function addQuestion() {
    const newQuestion = {
      id: Date.now(),
      type: "choice",
      question: "",
      options: ["選択肢1", "選択肢2"],
    }
    editingQuestions = [...editingQuestions, newQuestion]
  }

  function removeQuestion(questionId) {
    editingQuestions = editingQuestions.filter((q) => q.id !== questionId)
  }

  function updateQuestion(questionId, field, value) {
    editingQuestions = editingQuestions.map((q) =>
      q.id === questionId ? { ...q, [field]: value } : q
    )
  }

  function copyQuestionnaireSet(set) {
    isNewQuestionnaireSet = true
    selectedQuestionnaireSet = null

    editingQuestionnaireSetName = set.set_name + " (コピー)"
    editingQuestionnaireSetId = set.id + "_copy"
    editingQuestionnaireDescription = set.description || ""

    editingQuestions = (set.questions || []).map((q, index) => ({
      ...q,
      id: Date.now() + index,
      options: q.options ? [...q.options] : []
    }))

    editingGradeOptions = [...(set.grade_options || [])]
  }

  async function fetchQuestionnaireSets() {
    try {
      const apiUrl = API_URL + "/admin/questionnaire-sets"
      console.log("Fetching questionnaire sets from:", apiUrl)
      const response = await axios.get(apiUrl)
      questionnaireSets = response.data || []
      console.log("Fetched questionnaire sets:", questionnaireSets)
    } catch (error) {
      console.error("Failed to fetch questionnaire sets:", error)
      alert("アンケートセットの取得に失敗しました")
      questionnaireSets = []
    }
  }

  async function saveQuestionnaireSet() {
    if (isSavingQuestionnaire) return

    if (!editingQuestionnaireSetName.trim()) {
      alert("セット名を入力してください")
      return
    }
    if (!editingQuestionnaireSetId.trim()) {
      alert("セットIDを入力してください")
      return
    }
    if (editingQuestions.length === 0) {
      alert("最低1つの質問を追加してください")
      return
    }

    for (const q of editingQuestions) {
      if (!q.question.trim()) {
        alert("すべての質問に内容を入力してください")
        return
      }
      if (q.type === "choice" && (!q.options || q.options.length === 0)) {
        alert("選択肢形式の質問には最低1つの選択肢を追加してください")
        return
      }
    }

    try {
      isSavingQuestionnaire = true
      const apiUrl = API_URL + "/admin/questionnaire-sets"

      const requestData = {
        id: editingQuestionnaireSetId.trim(),
        set_name: editingQuestionnaireSetName.trim(),
        description: editingQuestionnaireDescription.trim(),
        grade_options: editingGradeOptions,
        questions: editingQuestions,
      }

      if (isNewQuestionnaireSet) {
        console.log("Creating new questionnaire set:", requestData)
        const response = await axios.post(apiUrl, requestData)
        console.log("Created successfully:", response.data)
        alert("新しいアンケートセットを作成しました")
      } else {
        console.log("Updating questionnaire set:", requestData)
        const response = await axios.put(
          `${apiUrl}/${editingQuestionnaireSetId}`,
          requestData
        )
        console.log("Updated successfully:", response.data)
        alert("アンケートセットを更新しました")
      }

      await fetchQuestionnaireSets()

      isNewQuestionnaireSet = false
      selectedQuestionnaireSet = questionnaireSets.find(
        (s) => s.id === editingQuestionnaireSetId
      )
    } catch (error) {
      console.error("Failed to save questionnaire set:", error)
      alert(
        "アンケートセットの保存に失敗しました: " +
          (error.response.data || error.message)
      )
    } finally {
      isSavingQuestionnaire = false
    }
  }

  async function deleteQuestionnaireSet(setId, setName) {
    if (
      !confirm(
        `「${setName}」を削除してもよろしいですか？この操作は取り消せません。`
      )
    ) {
      return
    }

    try {
      const apiUrl = API_URL + "/admin/questionnaire-sets"
      await axios.delete(`${apiUrl}/${setId}`)

      alert("アンケートセットを削除しました")

      await fetchQuestionnaireSets()

      if (selectedQuestionnaireSet && selectedQuestionnaireSet.id === setId) {
        selectedQuestionnaireSet = null
        isNewQuestionnaireSet = false
        editingQuestionnaireSetName = ""
        editingQuestionnaireSetId = ""
        editingQuestionnaireDescription = ""
        editingQuestions = []
        editingGradeOptions = []
      }
    } catch (error) {
      console.error("Failed to delete questionnaire set:", error)
      alert(
        "アンケートセットの削除に失敗しました: " +
          (error.response.data || error.message)
      )
    }
  }

  async function saveVocabularySet() {
    if (isSavingVocab) return

    // バリデーション
    if (!editingVocabSetName.trim()) {
      alert("セット名を入力してください")
      return
    }

    if (!editingVocabSetId.trim()) {
      alert("セットIDを入力してください")
      return
    }

    // 空の語彙をフィルタリング
    const filteredPositiveWords = editingPositiveWords.filter((word) =>
      word.trim()
    )
    const filteredNegativeWords = editingNegativeWords.filter((word) =>
      word.trim()
    )

    try {
      isSavingVocab = true
      const apiUrl = API_URL + "/admin/vocabulary-sets"

      const requestData = {
        id: editingVocabSetId.trim(),
        set_name: editingVocabSetName.trim(),
        description: editingVocabDescription.trim(),
        positive_words: filteredPositiveWords,
        negative_words: filteredNegativeWords,
      }

      if (isNewVocabSet) {
        // 新規作成
        console.log("Creating new vocabulary set:", requestData)
        const response = await axios.post(apiUrl, requestData)
        console.log("Created successfully:", response.data)
        alert("新しい語彙セットを作成しました")
      } else {
        // 更新
        console.log("Updating vocabulary set:", requestData)
        const response = await axios.put(
          `${apiUrl}/${editingVocabSetId}`,
          requestData
        )
        console.log("Updated successfully:", response.data)
        alert("語彙セットを更新しました")
      }

      // 成功後の処理
      isNewVocabSet = false

      // 最新状態を取得
      await fetchVocabularySets()

      // 保存したセットを選択状態にする
      const savedSet = vocabularySets.find(
        (set) => set.id === editingVocabSetId
      )
      if (savedSet) {
        selectVocabSet(savedSet)
      }
    } catch (error) {
      console.error("Error saving vocabulary set:", error)
      if (error.response && error.response.data) {
        alert(`保存に失敗しました: ${error.response.data}`)
      } else {
        alert("保存に失敗しました")
      }
    } finally {
      isSavingVocab = false
    }
  }

  async function deleteVocabularySet(setId, setName) {
    if (
      !confirm(
        `「${setName}」を削除してもよろしいですか？この操作は取り消せません。`
      )
    ) {
      return
    }

    try {
      const apiUrl = API_URL + "/admin/vocabulary-sets"
      console.log("Deleting vocabulary set:", setId)

      const response = await axios.delete(`${apiUrl}/${setId}`)
      console.log("Deleted successfully:", response.data)

      alert("語彙セットを削除しました")

      if (selectedVocabSet && selectedVocabSet.id === setId) {
        selectedVocabSet = null
        editingVocabSetName = ""
        editingVocabSetId = ""
        editingVocabDescription = ""
        editingPositiveWords = []
        editingNegativeWords = []
        isNewVocabSet = false
      }

      await fetchVocabularySets()
    } catch (error) {
      console.error("Error deleting vocabulary set:", error)
      if (error.response && error.response.data) {
        alert(`削除に失敗しました: ${error.response.data}`)
      } else {
        alert("削除に失敗しました")
      }
    }
  }

  $: if (!authState.isAuthenticated && !authState.isLoading) {
    push("/admin")
  }

  async function handleLogout() {
    const result = await adminAuth.logout()
    if (result.success) {
      push("/admin")
    }
  }

  function generateUrl() {
    if (
      !selectedTargetSetId ||
      !selectedVocabularySetId ||
      !selectedQuestionnaireSetId
    ) {
      alert("全ての項目を選択してください")
      return
    }

    const params = new URLSearchParams({
      t: selectedTargetSetId,
      v: selectedVocabularySetId,
      q: selectedQuestionnaireSetId,
    })

    generatedUrl = `${baseUrl}?${params.toString()}`
  }

  function copyToClipboard() {
    if (!generatedUrl) {
      alert("まずURLを生成してください")
      return
    }

    navigator.clipboard
      .writeText(generatedUrl)
      .then(() => {
        alert("URLをクリップボードにコピーしました")
      })
      .catch((err) => {
        console.error("コピーに失敗しました:", err)
        alert("コピーに失敗しました")
      })
  }

  async function saveTargetSet() {
    if (isSaving) return

    // バリデーション
    if (!editingSetName.trim()) {
      alert("セット名を入力してください")
      return
    }

    if (!editingSetId.trim()) {
      alert("セットIDを入力してください")
      return
    }

    if (hasEmptyWords) {
      alert("すべてのターゲット語を入力してください")
      return
    }

    try {
      isSaving = true
      const apiUrl = API_URL + "/admin/target-sets"

      const requestData = {
        id: editingSetId.trim(),
        set_name: editingSetName.trim(),
        description: editingDescription.trim(),
        target_words: editingWords.map((word) => ({
          id: word.id,
          word: word.word.trim(),
          type: word.type,
          enabled: word.enabled,
        })),
      }

      if (isNewSet) {
        // 新規作成
        console.log("Creating new target set:", requestData)
        const response = await axios.post(apiUrl, requestData)
        console.log("Created successfully:", response.data)
        alert("新しいターゲット語セットを作成しました")
      } else {
        // 更新
        console.log("Updating target set:", requestData)
        const response = await axios.put(
          `${apiUrl}/${editingSetId}`,
          requestData
        )
        console.log("Updated successfully:", response.data)
        alert("ターゲット語セットを更新しました")
      }

      // 成功後の処理
      isNewSet = false

      // 最新状態を取得
      await fetchTargetSets()

      // 保存したセットを選択状態にする
      const savedSet = targetSets.find((set) => set.id === editingSetId)
      if (savedSet) {
        selectSet(savedSet)
      }
    } catch (error) {
      console.error("Error saving target set:", error)
      if (error.response && error.response.data) {
        alert(`保存に失敗しました: ${error.response.data}`)
      } else {
        alert("保存に失敗しました")
      }
    } finally {
      isSaving = false
    }
  }
</script>

{#if authState.isLoading}
  <div class="loading-container">
    <div class="spinner" />
    <p class="loading-text">読み込み中...</p>
  </div>
{:else if authState.isAuthenticated}
  <AdminLayout bind:currentPage>
    {#if currentPage === "target-sets"}
      <div class="target-sets-grid">
        <div class="panel">
          <div class="panel-header">
            <h3>ターゲット語セット一覧</h3>
          </div>
          <div class="panel-body">
            <div class="list-controls">
              <button class="btn-primary create-new" on:click={createNewSet}
                >+ 新規セット</button
              >
            </div>

            <div class="sets-list">
              {#if targetSets.length === 0}
                <div class="empty-state">
                  <p>ターゲット語セットを読み込み中...</p>
                </div>
              {:else}
                {#each targetSets as set}
                  <div
                    class="set-card"
                    class:active={selectedSet && selectedSet.id === set.id}
                    on:click={() => selectSet(set)}
                  >
                    <div class="set-info">
                      <div class="set-name">
                        {set.name}
                      </div>
                      <div class="set-meta">{set.description}</div>
                      {#if set.target_words}
                        <div class="set-stats">
                          語数: {set.target_words.length}
                        </div>
                      {/if}
                    </div>
                    <div class="set-actions">
                      <button
                        class="btn-outline"
                        on:click={(e) => {
                          e.stopPropagation()
                          copyTargetSet(set)
                        }}>複製</button
                      >
                      {#if set.set_type !== "preset"}
                        <button
                          class="btn-outline danger"
                          on:click={(e) => {
                            e.stopPropagation()
                            deleteTargetSet(set.id, set.name)
                          }}>削除</button
                        >
                      {/if}
                    </div>
                  </div>
                {/each}
              {/if}
            </div>
          </div>
        </div>

        <!-- 右：セット編集 -->
        <div class="panel">
          <div class="panel-header">
            <h3>
              セット編集 {#if isNewSet}(新規作成){:else if selectedSet}(編集中){/if}
            </h3>
          </div>
          <div class="panel-body">
            <div class="form-row">
              <div class="form-group">
                <label>セット名</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="例：小学生版"
                  bind:value={editingSetName}
                />
              </div>
              <div class="form-group">
                <label>セットID（URL用）</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="例：elementary"
                  bind:value={editingSetId}
                  disabled={!isNewSet}
                />
              </div>
            </div>

            <div class="form-group">
              <label>説明</label>
              <textarea
                class="form-textarea"
                placeholder="セットの説明…"
                bind:value={editingDescription}
              />
            </div>

            <div class="form-group">
              <label>ターゲット語（肯定/否定・有効/無効）</label>

              <div class="words-controls">
                <button class="btn-outline" on:click={addNewWord}
                  >+ ターゲット語を追加</button
                >
              </div>

              <div class="words-table-container">
                <table class="words-table">
                  <thead>
                    <tr>
                      <th>語</th>
                      <th>肯定/否定</th>
                      <th>有効</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    {#each editingWords as word}
                      <tr>
                        <td>
                          <input
                            type="text"
                            class="table-input"
                            value={word.word}
                            on:input={(e) =>
                              updateWordText(word.id, e.target.value)}
                            placeholder="ターゲット語を入力"
                          />
                        </td>
                        <td>
                          <select
                            class="table-select"
                            value={word.type}
                            on:change={(e) =>
                              updateWordType(word.id, e.target.value)}
                          >
                            <option value="positive">肯定</option>
                            <option value="negative">否定</option>
                          </select>
                        </td>
                        <td>
                          <select
                            class="table-select status-select"
                            value={word.enabled ? "enabled" : "disabled"}
                            on:change={(e) =>
                              updateWordStatus(word.id, e.target.value)}
                          >
                            <option value="enabled">有効</option>
                            <option value="disabled">無効</option>
                          </select>
                        </td>
                        <td>
                          <div class="table-actions">
                            <button
                              class="btn-small"
                              on:click={() => duplicateWord(word)}>複製</button
                            >
                            <button
                              class="btn-small danger"
                              on:click={() => removeWord(word.id)}>削除</button
                            >
                          </div>
                        </td>
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </div>
            </div>

            <div class="form-actions">
              <button
                class="btn-primary"
                on:click={saveTargetSet}
                disabled={isSaving || !isFormValid}
              >
                {#if isSaving}
                  保存中...
                {:else if isNewSet}
                  作成
                {:else}
                  更新
                {/if}
              </button>
            </div>
          </div>
        </div>
      </div>
    {:else if currentPage === "vocabulary"}
      <div class="target-sets-grid">
        <!-- 左：語彙セット一覧 -->
        <div class="panel">
          <div class="panel-header">
            <h3>語彙セット一覧</h3>
          </div>
          <div class="panel-body">
            <div class="list-controls">
              <button
                class="btn-primary create-new"
                on:click={createNewVocabSet}
              >
                + 新規セット
              </button>
            </div>

            <div class="sets-list">
              {#if vocabularySets.length === 0}
                <div class="empty-state">
                  <p>語彙セットを読み込み中...</p>
                </div>
              {:else}
                {#each vocabularySets as set}
                  <div
                    class="set-card"
                    class:active={selectedVocabSet &&
                      selectedVocabSet.id === set.id}
                    on:click={() => selectVocabSet(set)}
                  >
                    <div class="set-info">
                      <div class="set-name">{set.set_name}</div>
                      <div class="set-meta">{set.description}</div>
                      <div class="set-stats">
                        ポジティブ語: {set.positive_words.length || 0} / ネガティブ語:
                        {set.negative_words.length || 0}
                      </div>
                    </div>
                    <div class="set-actions">
                      <button
                        class="btn-outline"
                        on:click={(e) => {
                          e.stopPropagation()
                          copyVocabularySet(set)
                        }}>複製</button
                      >
                      {#if set.set_type !== "preset"}
                        <button
                          class="btn-outline danger"
                          on:click={(e) => {
                            e.stopPropagation()
                            deleteVocabularySet(set.id, set.set_name)
                          }}>削除</button
                        >
                      {/if}
                    </div>
                  </div>
                {/each}
              {/if}
            </div>
          </div>
        </div>

        <!-- 右：セット編集 -->
        <div class="panel">
          <div class="panel-header">
            <h3>
              語彙セット編集 {#if isNewVocabSet}(新規作成){:else if selectedVocabSet}(編集中){/if}
            </h3>
          </div>
          <div class="panel-body">
            <div class="form-row">
              <div class="form-group">
                <label>セット名</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="例：小学生版語彙"
                  bind:value={editingVocabSetName}
                />
              </div>
              <div class="form-group">
                <label>セットID（URL用）</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="例：elementary"
                  bind:value={editingVocabSetId}
                  disabled={!isNewVocabSet}
                />
              </div>
            </div>

            <div class="form-group">
              <label>説明</label>
              <textarea
                class="form-textarea"
                placeholder="セットの説明…"
                bind:value={editingVocabDescription}
              />
            </div>

            <div class="vocabulary-tabs">
              <button
                class="tab-button"
                class:active={activeVocabTab === "positive"}
                on:click={() => switchVocabTab("positive")}
              >
                ポジティブ語
              </button>
              <button
                class="tab-button"
                class:active={activeVocabTab === "negative"}
                on:click={() => switchVocabTab("negative")}
              >
                ネガティブ語
              </button>
            </div>

            <div class="vocabulary-content">
              <div class="vocabulary-list">
                {#if activeVocabTab === "positive"}
                  <div class="form-actions">
                    <button
                      class="btn-outline"
                      on:click={() => addVocabWord("positive")}
                      >+ ポジティブ語を追加</button
                    >
                  </div>
                  {#each editingPositiveWords as word, index}
                    <div class="vocabulary-item">
                      <input
                        type="text"
                        class="form-input"
                        bind:value={editingPositiveWords[index]}
                        placeholder="ポジティブ語を入力"
                      />
                      <div class="vocabulary-actions">
                        <button
                          class="btn-small danger"
                          on:click={() => removeVocabWord("positive", index)}
                          >削除</button
                        >
                      </div>
                    </div>
                  {/each}
                {:else}
                  <div class="form-actions">
                    <button
                      class="btn-outline"
                      on:click={() => addVocabWord("negative")}
                      >+ ネガティブ語を追加</button
                    >
                  </div>
                  {#each editingNegativeWords as word, index}
                    <div class="vocabulary-item">
                      <input
                        type="text"
                        class="form-input"
                        bind:value={editingNegativeWords[index]}
                        placeholder="ネガティブ語を入力"
                      />
                      <div class="vocabulary-actions">
                        <button
                          class="btn-small danger"
                          on:click={() => removeVocabWord("negative", index)}
                          >削除</button
                        >
                      </div>
                    </div>
                  {/each}
                {/if}
              </div>
            </div>

            <div class="form-actions">
              <button
                class="btn-primary"
                disabled={isSavingVocab}
                on:click={saveVocabularySet}
              >
                {#if isSavingVocab}
                  保存中...
                {:else if isNewVocabSet}
                  作成
                {:else}
                  更新
                {/if}
              </button>
            </div>
          </div>
        </div>
      </div>
    {:else if currentPage === "questionnaire"}
      <div class="target-sets-grid">
        <!-- 左：アンケートセット一覧 -->
        <div class="panel">
          <div class="panel-header">
            <h3>アンケートセット一覧</h3>
          </div>
          <div class="panel-body">
            <div class="list-controls">
              <button
                class="btn-primary create-new"
                on:click={createNewQuestionnaireSet}
              >
                + 新規セット
              </button>
            </div>

            <div class="sets-list">
              {#if questionnaireSets.length === 0}
                <div class="empty-state">
                  <p>アンケートセットを読み込み中...</p>
                </div>
              {:else}
                {#each questionnaireSets as set}
                  <div
                    class="set-card"
                    class:active={selectedQuestionnaireSet &&
                      selectedQuestionnaireSet.id === set.id}
                    on:click={() => selectQuestionnaireSet(set)}
                  >
                    <div class="set-info">
                      <div class="set-name">{set.set_name}</div>
                      <div class="set-meta">{set.description}</div>
                      <div class="set-stats">
                        質問数: {set.questions.length || 0}
                      </div>
                    </div>
                    <div class="set-actions">
                      <button
                        class="btn-outline"
                        on:click={(e) => {
                          e.stopPropagation()
                          copyQuestionnaireSet(set)
                        }}>複製</button
                      >
                      {#if set.set_type !== "preset"}
                        <button
                          class="btn-outline danger"
                          on:click={(e) => {
                            e.stopPropagation()
                            deleteQuestionnaireSet(set.id, set.set_name)
                          }}>削除</button
                        >
                      {/if}
                    </div>
                  </div>
                {/each}
              {/if}
            </div>
          </div>
        </div>

        <!-- 右：セット編集 -->
        <div class="panel">
          <div class="panel-header">
            <h3>
              アンケートセット編集 {#if isNewQuestionnaireSet}(新規作成){:else if selectedQuestionnaireSet}(編集中){/if}
            </h3>
          </div>
          <div class="panel-body">
            <div class="form-row">
              <div class="form-group">
                <label>セット名</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="例：基本アンケート"
                  bind:value={editingQuestionnaireSetName}
                />
              </div>
              <div class="form-group">
                <label>セットID（URL用）</label>
                <input
                  type="text"
                  class="form-input"
                  placeholder="例：basic"
                  bind:value={editingQuestionnaireSetId}
                  disabled={!isNewQuestionnaireSet}
                />
              </div>
            </div>

            <div class="form-group">
              <label>説明</label>
              <textarea
                class="form-textarea"
                placeholder="セットの説明…"
                bind:value={editingQuestionnaireDescription}
              />
            </div>

            <div class="form-group">
              <label>学年選択肢</label>
              <div class="grade-options">
                {#each ["4年生", "5年生", "6年生", "中1", "中2", "中3", "高1", "高2", "高3", "その他"] as grade}
                  <label class="checkbox-label">
                    <input
                      type="checkbox"
                      checked={editingGradeOptions.includes(grade)}
                      on:change={(e) => {
                        if (e.target.checked) {
                          editingGradeOptions = [...editingGradeOptions, grade]
                        } else {
                          editingGradeOptions = editingGradeOptions.filter(
                            (g) => g !== grade
                          )
                        }
                      }}
                    />
                    {grade}
                  </label>
                {/each}
              </div>
            </div>

            <div class="form-group">
              <label>質問項目</label>
              <div class="questions-controls">
                <button class="btn-outline" on:click={addQuestion}
                  >+ 質問を追加</button
                >
              </div>
              <div class="question-list">
                {#each editingQuestions as question}
                  <div class="question-item">
                    <div class="question-header">
                      <input
                        type="text"
                        class="form-input"
                        placeholder="質問内容を入力"
                        bind:value={question.question}
                      />
                      <select class="form-select" bind:value={question.type}>
                        <option value="choice">選択式</option>
                        <option value="text">記述式</option>
                      </select>
                      <button
                        class="btn-small danger"
                        on:click={() => removeQuestion(question.id)}
                        >質問削除</button
                      >
                    </div>

                    {#if question.type === "choice"}
                      <div class="options-container">
                        <label>選択肢</label>
                        {#if !question.options}
                          {(question.options = ["選択肢1", "選択肢2"]) && ""}
                        {/if}
                        {#each question.options as option, index}
                          <div class="option-input-row">
                            <input
                              type="text"
                              class="form-input"
                              placeholder="選択肢 {index + 1}"
                              bind:value={question.options[index]}
                            />
                            <button
                              class="btn-small danger"
                              on:click={() => {
                                question.options = question.options.filter(
                                  (_, i) => i !== index
                                )
                                editingQuestions = editingQuestions
                              }}
                              disabled={question.options.length <= 1}
                            >
                              削除
                            </button>
                          </div>
                        {/each}
                        <button
                          class="btn-small"
                          on:click={() => {
                            question.options = [
                              ...question.options,
                              `選択肢${question.options.length + 1}`,
                            ]
                            editingQuestions = editingQuestions
                          }}
                        >
                          + 選択肢追加
                        </button>
                      </div>
                    {/if}
                  </div>
                {/each}
              </div>
            </div>

            <div class="form-actions">
              <button
                class="btn-primary"
                disabled={isSavingQuestionnaire}
                on:click={saveQuestionnaireSet}
              >
                {#if isSavingQuestionnaire}
                  保存中...
                {:else if isNewQuestionnaireSet}
                  作成
                {:else}
                  更新
                {/if}
              </button>
            </div>
          </div>
        </div>
      </div>
    {:else if currentPage === "url-generator"}
      <div class="page-content">
        <div class="page-header">
          <h3>URL生成</h3>
        </div>

        <div class="url-generator">
          <div class="generator-form">
            <div class="form-group">
              <label>ターゲット語セット</label>
              <select class="form-select" bind:value={selectedTargetSetId}>
                <option value="">選択してください</option>
                {#each targetSets as set}
                  <option value={set.id}>{set.name}</option>
                {/each}
              </select>
            </div>
            <div class="form-group">
              <label>語彙セット</label>
              <select class="form-select" bind:value={selectedVocabularySetId}>
                <option value="">選択してください</option>
                {#each vocabularySets as set}
                  <option value={set.id}>{set.set_name}</option>
                {/each}
              </select>
            </div>
            <div class="form-group">
              <label>アンケート設定</label>
              <select
                class="form-select"
                bind:value={selectedQuestionnaireSetId}
              >
                <option value="">選択してください</option>
                {#each questionnaireSets as set}
                  <option value={set.id}>{set.set_name}</option>
                {/each}
              </select>
            </div>
            <div class="form-group url-generate-btn-group">
              <button
                class="btn-primary large url-generate-btn"
                on:click={generateUrl}
              >
                URL生成
              </button>
            </div>
          </div>

          {#if generatedUrl}
            <div class="generated-url-section">
              <label>生成されたURL</label>
              <div class="url-output">
                <input
                  type="text"
                  readonly
                  value={generatedUrl}
                  class="url-input"
                />
                <button class="btn-primary" on:click={copyToClipboard}
                  >コピー</button
                >
              </div>
              <div class="url-info">
                <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">
                  <strong>パラメータ説明:</strong><br />
                  t={selectedTargetSetId} (ターゲット語セット)<br />
                  v={selectedVocabularySetId} (語彙セット)<br />
                  q={selectedQuestionnaireSetId} (アンケートセット)
                </p>
              </div>
            </div>
          {/if}
        </div>
      </div>
    {:else if currentPage === "results"}
      <div class="page-content">
        <div class="page-header">
          <h3>結果管理</h3>
          <button class="btn-primary">📁 CSVエクスポート</button>
        </div>

        <div class="results-filters">
          <input type="date" class="form-input" />
          <span>〜</span>
          <input type="date" class="form-input" />
          <select class="form-select">
            <option>全てのセット</option>
            <option>小学生版</option>
            <option>中高生版</option>
          </select>
          <button class="btn-outline">検索</button>
        </div>

        <div class="results-table">
          <table>
            <thead>
              <tr>
                <th>実施日時</th>
                <th>セット</th>
                <th>回答者</th>
                <th>スコア</th>
                <th>エラー</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2025-10-19 14:30</td>
                <td>小学生版</td>
                <td>user123</td>
                <td>0.25</td>
                <td>-</td>
              </tr>
              <tr>
                <td>2025-10-19 14:15</td>
                <td>中高生版</td>
                <td>user124</td>
                <td>エラー</td>
                <td>適当回答</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    {/if}
  </AdminLayout>
{/if}

<style lang="scss">
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: #f8fafc;
  }

  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e2e8f0;
    border-top: 4px solid #3b82f6;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-text {
    margin-top: 1rem;
    color: #64748b;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  // ダッシュボード
  .dashboard-content {
    max-width: 1200px;
  }

  .welcome-section {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 2rem;

    h3 {
      margin: 0 0 0.5rem 0;
      color: #1e293b;
      font-size: 1.5rem;
    }

    p {
      margin: 0;
      color: #64748b;
    }
  }

  .quick-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .stat-card {
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;

    .stat-info {
      h4 {
        margin: 0 0 0.25rem 0;
        font-size: 1.1rem;
        color: #1e293b;
      }

      p {
        margin: 0;
        color: #64748b;
        font-size: 0.9rem;
      }
    }
  }

  .actions-section {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .action-button {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &.primary {
      background: #3b82f6;
      color: white;

      &:hover {
        background: #2563eb;
      }
    }

    &.secondary {
      background: white;
      color: #475569;
      border: 1px solid #e2e8f0;

      &:hover {
        background: #f8fafc;
      }
    }
  }

  // 共通スタイル
  .page-content {
    max-width: 1200px;
  }

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;

    h3 {
      margin: 0;
      color: #1e293b;
      font-size: 1.5rem;
    }

    .btn-primary {
      width: auto;
      white-space: nowrap;
    }
  }

  .btn-primary {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: #2563eb;
    }

    &:disabled {
      background: #94a3b8;
      cursor: not-allowed;
    }

    &.large {
      padding: 1rem 2rem;
      font-size: 1.1rem;
    }
  }

  .btn-outline {
    background: white;
    color: #475569;
    border: 1px solid #e2e8f0;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;

    &:hover {
      background: #f8fafc;
    }

    &.danger {
      color: #dc2626;
      border-color: #fecaca;

      &:hover {
        background: #fef2f2;
      }
    }
  }

  .btn-small {
    padding: 0.25rem 0.75rem;
    font-size: 0.8rem;
    border: 1px solid #e2e8f0;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    width: auto; // ボタン幅を内容に合わせる

    &.danger {
      color: #dc2626;
      border-color: #fecaca;
    }
  }

  // ターゲット語セット管理
  .target-sets-grid {
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 1rem;
    max-width: 1400px;
    width: 100%;

    @media (max-width: 1024px) {
      grid-template-columns: 1fr;
      gap: 1rem;
    }

    @media (min-width: 1200px) {
      grid-template-columns: 350px 1fr;
      gap: 1.5rem;
    }
  }

  .panel {
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .panel-header {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;

    h3 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #1e293b;
    }
  }

  .panel-body {
    padding: 1.5rem;
  }

  .list-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    gap: 1rem;
  }

  .sets-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .set-card {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 1rem;
    background: #fafbfc;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 1rem;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: #c7d2fe;
    }

    &.active {
      border-color: #3b82f6;
      background: #eff6ff;
    }
  }

  .set-info {
    .set-name {
      font-weight: 600;
      color: #1e293b;
      margin-bottom: 0.25rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .set-meta {
      font-size: 0.875rem;
      color: #64748b;
      margin-bottom: 0.25rem;
    }

    .set-stats {
      font-size: 0.75rem;
      color: #9ca3af;
    }
  }

  .empty-state {
    text-align: center;
    padding: 2rem;
    color: #64748b;

    p {
      margin: 0;
      font-style: italic;
    }
  }

  .set-actions {
    display: flex;
    gap: 0.5rem;
  }

  .chip {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    background: #f1f5f9;
    color: #475569;
    font-size: 0.75rem;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .form-textarea {
    width: 100%;
    min-height: 72px;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9rem;
    resize: vertical;
    font-family: inherit;

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }

  .words-controls {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.5rem;
    .btn-outline {
      width: auto;
    }
  }

  .words-table-container {
    overflow-x: auto;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 1rem;
    max-height: 400px;
    overflow-y: auto;
    margin-top: 1rem;
  }

  .words-table {
    width: 100%;
    min-width: 500px;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;

    th,
    td {
      padding: 0.5rem;
      text-align: left;
      border-bottom: 1px solid #f1f5f9;
      font-size: 0.875rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    th {
      background: #f8fafc;
      font-weight: 600;
      color: #374151;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    // 列幅指定
    th:nth-child(1),
    td:nth-child(1) {
      width: 30%;
    } // 語
    th:nth-child(2),
    td:nth-child(2) {
      width: 20%;
    } // 肯定/否定
    th:nth-child(3),
    td:nth-child(3) {
      width: 20%;
    } // 有効
    th:nth-child(4),
    td:nth-child(4) {
      width: 30%;
    } // 操作

    tbody tr:last-child td {
      border-bottom: none;
    }
  }

  .table-input,
  .table-select {
    width: 100%;
    padding: 0.375rem 0.5rem;
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    font-size: 0.8rem;
    min-width: 0;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #3b82f6;
    }
  }

  .status-select {
    min-width: 85px;
    font-size: 0.75rem;
  }

  .table-actions {
    display: flex;
    gap: 0.25rem;
    justify-content: flex-end;
    flex-wrap: nowrap;

    .btn-small {
      font-size: 0.7rem;
      padding: 0.25rem 0.5rem;
      white-space: nowrap;
    }
  }

  .help-text {
    font-size: 0.875rem;
    color: #64748b;
    line-height: 1.5;
    margin: 0;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #f1f5f9;
  }

  .form-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9rem;
    font-family: inherit;

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &:disabled {
      background: #f1f5f9;
      color: #64748b;
    }
  }

  .form-select {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9rem;
    background: white;
    font-family: inherit;

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }

  .form-group {
    margin-bottom: 1.5rem;

    label {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: 600;
      color: #374151;
      font-size: 0.9rem;
    }

    .btn-outline {
      width: auto;
    }
  }

  // 語彙管理
  .vocabulary-tabs {
    display: flex;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    width: 100%;
  }

  .tab-button {
    background: none;
    border: none;
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    color: #64748b;
    border-bottom: 2px solid transparent;
    flex: 1; // 各タブが均等な幅を占める
    text-align: center;
    transition: all 0.2s ease;

    &.active {
      color: #3b82f6;
      border-bottom-color: #3b82f6;
    }

    &:hover {
      color: #3b82f6;
      background: rgba(59, 130, 246, 0.05);
    }
  }

  .vocabulary-content {
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    .btn-outline {
      width: auto;
    }
  }

  .vocabulary-list {
    margin-bottom: 1.5rem;
  }

  .vocabulary-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f1f5f9;
    gap: 1rem;

    .word {
      font-weight: 500;
      color: #1e293b;
    }

    .form-input {
      flex: 1;
    }
  }

  .vocabulary-actions {
    display: flex;
    gap: 0.5rem;
  }

  .add-vocabulary {
    display: flex;
    gap: 1rem;
    align-items: center;

    .btn-primary {
      width: auto;
      white-space: nowrap;
    }
  }

  .vocabulary-input {
    flex: 1;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9rem;
  }

  .grade-options {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 0.5rem;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    font-weight: normal;

    input {
      margin-right: 0.5rem;
    }
  }

  .question-list {
    margin-bottom: 1rem;
  }

  .question-item {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 1rem;
    background: #f8fafc;
  }

  .question-header {
    display: flex;
    align-items: center;
    gap: 1rem;

    .form-input {
      flex: 2;
    }

    .form-select {
      flex: 1;
      min-width: 120px;
    }

    .btn-small {
      flex-shrink: 0;
    }
  }

  .options-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;
    background: white;
    border-radius: 6px;
    border: 1px solid #e2e8f0;

    label {
      font-weight: 600;
      color: #334155;
      margin-bottom: 0.5rem;
    }
  }

  .option-input-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;

    .form-input {
      flex: 1;
    }

    .btn-small {
      flex-shrink: 0;
    }
  }

  // URL生成
  .url-generator {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .generator-form {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
    align-items: end;
    margin-bottom: 2rem;
  }

  .url-generate-btn-group {
    display: flex;
    align-items: flex-end;
    height: 100%;
  }

  .url-generate-btn {
    width: 100%;
    height: 56px;
    font-size: 1.15rem;
    display: block;
  }

  .generated-url-section {
    label {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: 500;
    }
  }

  .questions-controls {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.5rem;

    .btn-outline {
      width: auto;
    }
  }

  .url-output {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  .url-input {
    flex: 1;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #f8fafc;
    font-family: monospace;
    font-size: 0.9rem;
  }

  // テーブル
  .results-filters {
    display: flex;
    gap: 1rem;
    align-items: center;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;

    .form-input,
    .form-select {
      width: auto;
      min-width: 120px;
    }
  }

  .results-table {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    table {
      width: 100%;
      border-collapse: collapse;
    }

    th,
    td {
      padding: 1rem;
      text-align: left;
      border-bottom: 1px solid #f1f5f9;
    }

    th {
      background: #f8fafc;
      font-weight: 600;
      color: #374151;
    }

    td {
      color: #6b7280;
    }
  }

  .create-new {
    width: auto;
  }

  .set-actions .btn-outline {
    width: auto;
  }

  .table-actions .btn-small {
    width: auto;
  }

  .form-actions button {
    width: auto;
  }

  .url-generator {
    button {
      width: auto;
    }
  }
</style>
